const getImagePrefix = window.location.origin + "/getImage";

const getCookie = name => {
	const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
	const arr = document.cookie.match(reg);
	if (arr) {
		return unescape(arr[2]);
	}
	return "";
};

const getUrlParams = name => {
	const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
	const r = window.location.search.substr(1).match(reg);
	if (r != null) {
		return decodeURIComponent(r[2]);
	}
	return "";
};
const compressedBase64 = (file, callback) => {
	console.log("gggggt callback", file, img);
	const img = new Image();
	if (!file) return;
	img.src = file || "";
	console.log("gggggt callback", file, img);

	img.onload = () => {
		const imgSize = {
			width: img.width > 1300 ? 1300 : img.width,
			height: img.width > 1300 ? (1300 * img.height) / img.width : img.height
		};
		const elem = document.createElement("canvas");
		elem.width = imgSize.width; // width;
		elem.height = imgSize.height; // (width / imgSize.width) * imgSize.height;
		const ctx = elem.getContext("2d");
		// canvas大小设置
		console.log("ctx gggg");
		if (ctx) {
			console.log("进了");
			ctx.fillStyle = "#fff";
			ctx.fillRect(0, 0, elem.width, elem.height);
			ctx.drawImage(img, 0, 0, elem.width, elem.height);
			const compressed = ctx.canvas.toDataURL("image/jpeg", 0.3);
			callback instanceof Function && callback(file, compressed);
		}
	};
};
export { getCookie, getUrlParams, compressedBase64, getImagePrefix };
